$(document).ready(() => {
    const $recipeMethods = $(".js-recipe-method");

    $recipeMethods.each((index, $recipe) => {
        // Cache the recipe instructions
        const $instructions = $(".js-recipe-instructions", $recipe);
        const $instructionsList = $("ol", $instructions).children();
        const $readToggler = $(".js-read-more", $recipe);

        // Check if the instructions is exceeding provided number of steps and hide it
        const stepsToShow = parseInt($instructions.data("stepsToShow"), 10);

        if ($instructionsList && $instructionsList.length > stepsToShow) {
            $instructionsList.each((index, item) => {
                if (index > (stepsToShow - 1)) {
                    $(item).addClass("d-none");
                }
            });
        } else {
            $readToggler.remove();
        }

        // Show the hidden steps and remove the button
        $readToggler.on("click", () => {
            $instructionsList.removeClass("d-none");
            $readToggler.remove();
        });
    });
});
